import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShowAudanetTaskDetailsComponent } from './components/show-audanet-task-details/show-audanet-task-details.component';


const routes: Routes = [
  {
    path: 'taskInfo/:taskId/:audanetOperationType/:claimId',
    component: ShowAudanetTaskDetailsComponent
  },
  {
    path: 'taskInfo/:taskId/:audanetOperationType/:claimId/:costEstimationId',
    component: ShowAudanetTaskDetailsComponent
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AudanetInegrationRoutingModule { }
